import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useApi } from "@platform/api";

export type AnalystTeam = {
  id: number;
  name: string;
  description?: string;
};

export type AnalystTeamsResponse = {
  teams: AnalystTeam[];
};

export const useAnalystTeams = (): UseQueryResult<
  AnalystTeamsResponse,
  Error
> => {
  const axiosInstance = useApi();

  return useQuery({
    queryKey: ["analystTeams"],
    queryFn: async (): Promise<AnalystTeamsResponse> => {
      const { data: response } = await axiosInstance.get<AnalystTeamsResponse>(
        "/brokerportal/v1/analysts/teams",
      );
      return response;
    },
    initialData: { teams: [] },
  });
};
